import {
  IonButton,
  IonContent,
  IonHeader,
  IonItem,
  IonLabel,
  IonList,
  IonPage,
  IonTitle,
  IonToolbar,
} from "@ionic/react";
import { IssueList } from "components/Organisms/IssueList/IssueList";
import { usePanelFlow } from "components/PanelFlow";

import { translate } from "~utils";

import { ReportIssueKey, ReportIssueModalProps } from "../types";

type ReportIssueListProps = ReportIssueModalProps & {
  goToPanel: (panelKey: string) => void;
};

export function ReportIssueList(props: ReportIssueListProps) {
  const { setState, goToPanel, onDismiss, extraProps } = props;
  const { subName, intervals, requestId, status, subId, school } = extraProps;

  const onEditClick = (intervalId: number) => {
    setState({ initialIntervalId: intervalId });

    goToPanel(ReportIssueKey.ReportIssueFormPanel);
  };

  return (
    <IonPage>
      <IonHeader>
        <IonToolbar>
          <IonTitle>{translate("REPORT_ISSUE_ISSUES_HEADER")}</IonTitle>
        </IonToolbar>
      </IonHeader>
      <IonContent>
        <IonList>
          <IonItem lines="none">
            <IonLabel>{translate("REPORT_ISSUE_ISSUES_MESSAGE", subName)}</IonLabel>
          </IonItem>
          <div
            css={{
              padding: "16px 12px",
              display: "flex",
              flexDirection: "column",
              gap: 16,
              marginTop: "auto",
            }}
          >
            <IonButton onClick={() => goToPanel(ReportIssueKey.ReportIssueFormPanel)}>
              {translate("REPORT_ISSUE_LIST_PRIMARY_BUTTON_TEXT")}
            </IonButton>
            <IonButton fill="outline" onClick={() => onDismiss()}>
              {translate("REPORT_ISSUE_LIST_SECONDARY_BUTTON_TEXT")}
            </IonButton>
          </div>
          <div css={{ backgroundColor: "var(--ion-color-primary-contrast)" }}>
            <IssueList
              school={school}
              onEditClickProp={onEditClick}
              intervals={intervals}
              requestId={requestId}
              status={status}
              subId={subId}
              subName={subName}
              variant="FULL"
            />
          </div>
        </IonList>
      </IonContent>
    </IonPage>
  );
}

export function ReportIssueListPanel() {
  const panelFlowProps = usePanelFlow();
  const { goToPanel, state, setState, extraProps } = panelFlowProps;

  return (
    <ReportIssueList
      goToPanel={goToPanel}
      state={state}
      setState={setState}
      extraProps={extraProps}
      onDismiss={extraProps.onDismiss}
    />
  );
}
